import type { PostDto } from './api'

/**
 * Teks pengenal sebuah post untuk daftar & kalender.
 *
 * Instagram tidak punya "judul" seperti Pinterest — yang ada hanya caption.
 * Dipusatkan di sini supaya setiap tempat memotongnya dengan cara yang sama.
 */
export function labelPost(post: PostDto): string {
  const c = post.caption?.trim()
  if (c) return c.length > 60 ? `${c.slice(0, 60)}…` : c
  return post.format === 'reel' ? '(reel without caption)' : '(no caption)'
}

/** Media pertama sebuah post — yang ditampilkan sebagai thumbnail. */
export function mediaUtama(post: PostDto) {
  return post.slides[0]?.media ?? null
}
